import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-ff-ltv-field',
  templateUrl: 'ltv-field.component.html',
})
export class FormlyLtvFieldComponent extends FieldType {

}
